import { render, staticRenderFns } from "./TreatmentItem.vue?vue&type=template&id=3852cc50&scoped=true&lang=pug&"
import script from "./TreatmentItem.vue?vue&type=script&lang=js&"
export * from "./TreatmentItem.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentItem.vue?vue&type=style&index=0&id=3852cc50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3852cc50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VIcon,VSpacer})
